import { render, staticRenderFns } from "./ServiceUnavailableContent.vue?vue&type=template&id=2dae09cf"
import script from "./ServiceUnavailableContent.vue?vue&type=script&lang=js"
export * from "./ServiceUnavailableContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports